import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
import AOS from "aos";
import { Link } from "react-router-dom";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
import { Container, Row, Col, Form } from "react-bootstrap";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPaperPlane,
  FaWhatsapp,
  FaInstagram,
} from "react-icons/fa";

import Navr from "../Navbar/Navr";
import Footer from "./Footer";
import contactBg from "../Ecomphotos/s1.jpg";

export default function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    // 🔴 IMPORTANT: Niche apni IDs paste karein
    const YOUR_SERVICE_ID = "service_qplv78c"; // Step 2 wali ID
    const YOUR_TEMPLATE_ID = "template_8bub19g"; // Step 3 wali ID
    const YOUR_PUBLIC_KEY = "Naul2wISGUE1XaOsQ"; // Step 4 wali Key

    emailjs
      .sendForm(
        YOUR_SERVICE_ID,
        YOUR_TEMPLATE_ID,
        form.current,
        YOUR_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Thank you for contacting us.");
          e.target.reset(); // Form clear karne ke liye
        },
        (error) => {
          console.log(error.text);
          alert("Not sent");
        }
      );
  };
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="contact-page">
      <Navr />

      {/* --- Section 1: Hero Banner --- */}
      <div
        className="contact-hero d-flex align-items-center justify-content-center"
        style={{ backgroundImage: `url(${contactBg})` }}
      >
        <div className="hero-overlay"></div>
        <Container className="text-center position-relative z-2">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h5 className="text-warning text-uppercase ls-2 mb-3">
              Get in Touch
            </h5>
            <h1 className="display-4 fw-bold text-white mb-4">Contact Us</h1>
            <p
              className="text-white lead mx-auto opacity-75"
              style={{ maxWidth: "700px" }}
            >
              Have questions or ready to book your dream vacation? We are here
              to help 24/7.
            </p>
          </motion.div>
        </Container>
      </div>

      {/* --- Section 2: Contact Info & Form --- */}
      <section className="py-5 bg-light">
        <Container className="my-4">
          <Row className="g-5">
            {/* Left Side: Contact Information */}
            <Col lg={5} data-aos="fade-right">
              <div className="contact-details p-4 p-md-5 bg-white shadow-lg rounded-4 h-100">
                <h3 className="fw-bold mb-4 text-dark">Contact Information</h3>
                <p className="text-muted mb-5">
                  Plan your trip with the best travel experts. Reach out to us
                  via phone, email, or visit our office.
                </p>

                {/* Info Items */}
                <div className="d-flex align-items-start mb-4">
                  <div className="icon-box bg-light-danger text-danger me-3">
                    <FaPhoneAlt />
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">Phone Number</h6>
                    <p className="mb-0 text-muted">+91 98280-74121</p>
                    {/* <p className="mb-0 text-muted">+91 98765-43210</p> */}
                  </div>
                </div>

                <div className="d-flex align-items-start mb-4">
                  <div className="icon-box bg-light-warning text-warning me-3">
                    <FaEnvelope />
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">Email Address</h6>
                    <p className="mb-0 text-muted">jawaliholidays@gmail.com</p>
                  </div>
                </div>

                <div className="d-flex align-items-start mb-5">
                  <div className="icon-box bg-light-info text-info me-3">
                    <FaMapMarkerAlt />
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">Office Location</h6>
                    <p className="mb-0 text-muted">
                      125-A-1, Shop No. 03, 1st B Road, <br /> Sardarpura,
                      Jodhpur, Rajasthan
                    </p>
                  </div>
                </div>

                {/* Social Links */}
                <h6 className="fw-bold mb-3">Follow Us</h6>
                <div className="d-flex gap-3">
                  <Link
                    to="https://www.instagram.com/jawaliholidays?igsh=MTJ3MXRwOXoxNnN1aw=="
                    className="social-btn instagram"
                  >
                    <FaInstagram />
                  </Link>
                  <Link
                    to="https://wa.me/919828074121"
                    className="social-btn whatsapp"
                  >
                    <FaWhatsapp />
                  </Link>
                </div>
              </div>
            </Col>

            {/* Right Side: Inquiry Form */}
            <Col lg={7} data-aos="fade-left">
              <div className="contact-form-wrapper p-4 p-md-5 bg-white shadow-lg rounded-4">
                <h3 className="fw-bold mb-2 text-danger">Send us a Message</h3>
                <p className="text-muted mb-4">
                  Fill out the form below and our team will get back to you
                  within 24 hours.
                </p>

                <Form ref={form} onSubmit={sendEmail}>
                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">
                          Your Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="user_name"
                          placeholder=""
                          className="form-input"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">
                          Phone Number
                        </Form.Label>
                        <Form.Control
                          type="tel"
                          name="user_mobile"
                          placeholder=""
                          className="form-input"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">
                          Email Address
                        </Form.Label>
                        <Form.Control
                          type="email"
                          name="user_email"
                          placeholder=""
                          className="form-input"
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={12}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">
                          Message
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          name="message"
                          rows={5}
                          placeholder="Tell us about your travel plans..."
                          className="form-input"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col numberOfLines={12}>
                      <button
                        type="submit"
                        className="btn btn-danger w-100 py-3 fw-bold rounded-3 shadow hover-lift"
                      >
                        Send Message <FaPaperPlane className="ms-2" />
                      </button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* --- Section 3: Google Map --- */}
      <section className="map-section">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3577.421997337387!2d73.00874701098925!3d26.28041638688129!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39418db158ce313f%3A0x24cb10389c1e6981!2sJawali%20Holidays!5e0!3m2!1sen!2sin!4v1765635937821!5m2!1sen!2sin"
          title="Jawali Holidays Location"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>

      <Footer />
    </div>
  );
}
